import { Component, createSignal, createEffect, For } from "solid-js";

type PageListProps = {
    maxPage: number;
    blockSize: number;
    page: number;
    onClick: (page: number) => void;
};
export const PageList: Component<PageListProps> = (props) => {
    const [pageBlock, setPageBlock] = createSignal<number[]>([]);
    const getPageBlockStart = (pageIndex: number, pageBlockSize: number) => {
        var pageBlock = Math.floor((pageIndex / pageBlockSize) + 1);
        var pageBlockStart = ((pageBlock - 1) * pageBlockSize) + 1;
        return pageBlockStart;
    };
    const getPageRange = (page: number, rangeSize: number, maxPage: number) => {
        var start = getPageBlockStart(page, rangeSize);
        var end = start + rangeSize - 1;
        if (end > maxPage) {
            end = maxPage;
        }
        var pages = [];
        for (var i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };
    const skipToPreviousBlock = async () =>{
        const pageBlockStart = getPageBlockStart(props.page, props.blockSize);
        if (pageBlockStart - props.blockSize >= 1) {
            const previousPageBlockStart = pageBlockStart - props.blockSize;
            props.onClick(previousPageBlockStart);
        }
    };
    const skipToNextBlock = async () =>{
        const pageBlockStart = getPageBlockStart(props.page, props.blockSize);
        if (pageBlockStart + props.blockSize <= props.maxPage) {
            const nextPageBlockStart = pageBlockStart + props.blockSize;
            props.onClick(nextPageBlockStart);
        }
    };
    const skipToFirst = () => props.onClick(1);
    const skipToLast = () => props.onClick(props.maxPage);
    createEffect(() => {
        const _pageBlock = getPageRange(props.page, props.blockSize, props.maxPage);
        setPageBlock(_pageBlock);
    });
    return (
        <div style="padding-bottom: 10px;">
            <span class="alphabet-index" onClick={skipToFirst}>«</span>
            <span class="alphabet-index" onClick={skipToPreviousBlock}>‹</span>
            <For each={pageBlock()}>{(p) => <span class="alphabet-index" classList={{ ["active-letter"]: props.page == p }} onClick={() => props.onClick(p)}>{p}</span>}</For>
            <span class="alphabet-index" onClick={skipToNextBlock}>›</span>
            <span class="alphabet-index" onClick={skipToLast}>»</span>
        </div>
    );
};